import Swal from 'sweetalert2';
import '../../../../Styles/AdminResponseAlert.css';

const ADMIN_CONFIRM_COLOR = '#17365d';

const ADMIN_TOAST_CLASS = {
  popup: 'admin-response-alert',
  htmlContainer: 'admin-response-alert__html',
};

const ADMIN_MODAL_CLASS = {
  popup: 'admin-response-alert admin-response-alert--modal',
  title: 'swal-title-custom admin-response-alert__modal-title',
  htmlContainer: 'swal-text-custom admin-response-alert__modal-text',
};

const buildAdminErrorModalClass = (text) => ({
  ...ADMIN_MODAL_CLASS,
  htmlContainer: isDetailedError(text)
    ? 'swal-text-custom admin-response-alert__modal-text admin-response-alert__modal-text--scrollable'
    : ADMIN_MODAL_CLASS.htmlContainer,
});

const ADMIN_MODAL_BASE_OPTIONS = {
  animation: false,
  showConfirmButton: true,
  confirmButtonText: 'OK',
  confirmButtonColor: ADMIN_CONFIRM_COLOR,
  allowOutsideClick: true,
  allowEscapeKey: true,
  customClass: ADMIN_MODAL_CLASS,
};

const TOAST_TIMER_MS = 2200;

const ADMIN_TOAST_BASE_OPTIONS = {
  animation: false,
  showConfirmButton: false,
  toast: true,
  position: 'top-end',
  timer: TOAST_TIMER_MS,
  timerProgressBar: false,
  width: 'auto',
  customClass: ADMIN_TOAST_CLASS,
};

const DETAILED_ERROR_LINE_THRESHOLD = 120;

const escapeHtml = (value = '') =>
  String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

const buildToastHtml = (type, message) => `
  <div class="admin-response-alert__content" role="status">
    <span class="admin-response-alert__icon admin-response-alert__icon--${type}" aria-hidden="true"></span>
    <span class="admin-response-alert__message">${escapeHtml(message)}</span>
  </div>
`;

const buildToastMessage = (title, text) => {
  const normalizedTitle = String(title || '').trim();
  const normalizedText = String(text || '').trim();

  if (!normalizedText || normalizedText === normalizedTitle) {
    return normalizedTitle;
  }

  return `${normalizedTitle}. ${normalizedText}`;
};

const isDetailedError = (text) => {
  const normalizedText = String(text || '').trim();
  return normalizedText.includes('\n') || normalizedText.length > DETAILED_ERROR_LINE_THRESHOLD;
};

const showAdminToast = (type, message) =>
  Swal.fire({
    ...ADMIN_TOAST_BASE_OPTIONS,
    html: buildToastHtml(type, message),
  });

export const showAdminSuccess = (message) =>
  showAdminToast('success', message);

export const showAdminError = (title, text) => {
  const normalizedTitle = String(title || '').trim();
  const normalizedText = String(text || '').trim();
  const hasSeparateText = normalizedText && normalizedText !== normalizedTitle;

  return Swal.fire({
    ...ADMIN_MODAL_BASE_OPTIONS,
    icon: 'error',
    title: normalizedTitle,
    customClass: buildAdminErrorModalClass(normalizedText),
    ...(hasSeparateText ? { text: normalizedText } : {}),
  });
};

export const showAdminWarning = (title, text) => {
  const normalizedText = String(text || '').trim();

  if (isDetailedError(normalizedText)) {
    return Swal.fire({
      animation: false,
      title,
      text: normalizedText,
      icon: 'warning',
      confirmButtonText: 'OK',
      confirmButtonColor: ADMIN_CONFIRM_COLOR,
      customClass: ADMIN_MODAL_CLASS,
    });
  }

  return showAdminToast('warning', buildToastMessage(title, normalizedText));
};

export const showAdminInfo = (title, text) => {
  const normalizedText = String(text || '').trim();

  if (isDetailedError(normalizedText)) {
    return Swal.fire({
      animation: false,
      title,
      text: normalizedText,
      icon: 'info',
      confirmButtonText: 'OK',
      confirmButtonColor: ADMIN_CONFIRM_COLOR,
      customClass: ADMIN_MODAL_CLASS,
    });
  }

  return showAdminToast('info', buildToastMessage(title, normalizedText));
};
